import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { HomeService } from 'src/services/HomeService';
import { HomeSliceState, HomeFeedResponse } from 'src/types';

export const getFeed = createAsyncThunk('home/getFeed', async (param: Record<string, any>) => {
  return new HomeService().getFeed(param);
});

const slice = createSlice({
  name: 'home',
  initialState: {
    metadata: {
      total_count: 0,
      page: 0,
      total_page: 0,
      per_page: 0
    },
    data: [],
    status: ''
  } as HomeSliceState,
  extraReducers: (builder) => {
    builder
      .addCase(getFeed.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(getFeed.fulfilled, (state, action: PayloadAction<HomeFeedResponse>) => {
        state.status = 'success';
        state.metadata = action.payload.metadata;
        state.data = [...state.data, ...action.payload.data];
      })
      .addCase(getFeed.rejected, (state) => {
        state.status = 'failed';
      });
  },
  reducers: {}
});

export const reducer = slice.reducer;
export const actions = slice.actions;

export default slice;
